"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultErrorMessageTitle = exports.ErrorMessage = void 0;
var _mui = require("@ori-ui/mui");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const defaultErrorMessageTitle = exports.defaultErrorMessageTitle = 'Error';
const ErrorMessage = ({
  children,
  title = defaultErrorMessageTitle
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Alert, {
  severity: "error",
  sx: _styles.alertStyle,
  variant: "outlined",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.AlertTitle, {
    sx: _styles.alertTitleStyle,
    children: title
  }), children]
});
exports.ErrorMessage = ErrorMessage;
